var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.59063 8.57996L1.77293 5.76227C1.57816 5.56749 1.26254 5.56694 1.06708 5.76102L0.356683 6.46641C0.160732 6.66098 0.159613 6.97756 0.354184 7.17352L0.355431 7.17477L4.23707 11.0564C4.43233 11.2517 4.74892 11.2517 4.94418 11.0564L14.2371 1.76352C14.4323 1.56825 14.4323 1.25167 14.2371 1.05641L13.5342 0.353516L13.534 0.353722C13.3388 0.15854 13.0224 0.158448 12.8271 0.353516L4.59063 8.57996Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.60bceb95.svg";
export { ForwardRef as ReactComponent };